Reflux = require 'reflux'

module.exports = Reflux.createStore
  init: ->
    @videos = [
      { name:'Earth', video: 'video-65' }
      { name:'Table', video: 'video-156' }
      { name:'Inferno', video: 'video-142' }
      { name:'Hacienda', video: 'video-138' }
      { name:'Paradise', video: 'video-148' }
      { name:'Piña', video: 'video-149' }
      { name:'Fire', video: 'video-157' }
    ]



/** WEBPACK FOOTER **
 ** ./src/scripts/stores/age-gate-video-store.coffee
 **/